import { createSelector } from "reselect";
import { populationPrevalenceChartDataSelector } from "../population_prevalence_chart_data_selector";

export const populationPrevalenceChartDataLoadStateSelector = createSelector(
  populationPrevalenceChartDataSelector,
  chartData => chartData.loadState
);
